// © Microsoft Corporation. All rights reserved.

export const meControlComponentContainerId = "me-control";

export const baseMeControlScriptUrl = "https://mem.gfx.ms/meversion?partner={0}&market={1}";

export const baseSignInUrl = "https://login.live.com/login.srf?wa=wsignin1.0&wp=LBI&mkt={0}&wreply=https%3a%2f%2fwww.msn.com%2f{0}%2fhomepage%2fSecure%2fPassport%3fru%3d{1}";

export const baseSignOutUrl = "https://login.live.com/logout.srf?id=1184&mkt={0}&lru=https%3a%2f%2fwww.msn.com%2f{0}%2fhomepage%2fSecure%2fPassport%3fru%3d{1}";

export const baseMeUrl = "https://login.live.com/me.srf?wa=wsignin1.0&wp=LBI&mkt={0}&wreply=https%3a%2F%2Fwww.msn.com%2F{0}%2Fhomepage%2FSecure%2FPassport%3Fru%3D{1}";